<template>
  <div class="fullscreen">
    <div class="fullscreen-container" :class="{'ready' : videoReady}">
      <video id="fullscreen-video" ref="video" autoplay="" name="media" :muted="videoMuted"><source src="/static/video/sky-video.mp4" type="video/mp4"></video>
      <div class="video-mute-btn" :class="{'muted' : !videoMuted}" @click="toggleAudio"></div>
    </div>
    <div class="fullscreen__close" @click="closeVideoPopup"></div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'FullscreenPopup',
  data: () => ({
    videoReady: false,
    videoContainer: null,
    videoMuted: true,
  }),
  computed: {
    ...mapState(['showGallery'])
  },
  mounted() {
    document.querySelector('.custom-header').style.opacity = '0'
    this.videoContainer = this.$refs.video
    this.videoContainer.addEventListener('canplay', () => {
      this.videoReady = true
    })
    if (this.showGallery) {
      this.toggleGallery();
      }
  },
  beforeDestroy() {
    document.querySelector('.custom-header').style.opacity = '1'
  },
  methods: {
    ...mapMutations(['closeVideoPopup', 'toggleGallery']),
    toggleAudio() {
      if (!this.$refs.video) return
      this.videoMuted = !this.videoMuted;
    }
  }
}
</script>

<style lang="stylus">
@import '../styles/tools.styl'
  .fullscreen
    width 100vw
    height 100vh
    background rgba(0,0,0,0.7)
    display flex
    align-items center
    z-index 502
    &-container
      position absolute 
      width 100%
      height 100vh
      opacity 0
      transition opacity .2s ease-in-out
      &.ready
        opacity 1
      & video
        position absolute
        top 50%
        left 50%
        transform translate3d(-50%,-50%,0)
        min-height 100vh
        min-width 100vw

    &__close
      background-color transparent
      background-image url('/static/images/close.svg')
      background-position center
      background-size cover
      position absolute
      width 40px
      height 40px
      top 100px
      right 30px
      border 0
      cursor: pointer
      @media (min-width 600px) and (max-width 1000px)
        width-between-property 'top' 600 100 1000 200 true true
        width-between-property 'right' 600 30 1000 80 true true
      @media (min-width 1000px)
        top 80px
        right 80px

  .video-mute-btn
    position absolute
    bottom 40px
    left calc(10vw + 70px)
    width 30px
    height 30px
    background url('../static/images/vol-off.svg') center no-repeat
    background-size contain
    cursor pointer

    &.muted
      background url('../static/images/vol-on.svg') center no-repeat
      background-size contain

        
        

</style>